export default __webpack_public_path__ + "static/media/arrow_forward.acf844c1.svg";